import 'core-js/stable';
import FAD from './fad.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.fad-spa').forEach((el) => (el.classList.contains('load') ? new FAD(el) : null));
});
